import React from 'react';
import { styles } from './SellerProfile.css';
import { LoadingSkeleton } from '../../LoadingSkeleton/LoadingSkeleton';

export type SellerProfile = {
  name: string;
  logoSrc?: string;
  subTitle?: string;
  description?: string;
};

export const SellerProfile = ({ name, logoSrc, subTitle, description }: SellerProfile) => {
  return (
    <div className={styles.sellerProfile}>
      {logoSrc ? (
        <img className={styles.sellerLogo} src={logoSrc} alt={name} />
      ) : (
        <LoadingSkeleton.Image className={styles.sellerLogo} shouldShimmer={false} />
      )}
      <h1 className={styles.sellerTitle}>{name}</h1>
      <p className={styles.sellerSubTitle}>{subTitle}</p>
      {description ? <p className={styles.sellerDescription}>{description}</p> : null}
    </div>
  );
};
